import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './_guards/index';
import { HomeComponent } from './home';
import { SignUpComponent } from './blockchainImpExp/sign-up/sign-up.component';
import { ChallanOneComponent } from './blockchainImpExp/imp_exp/payment/challan-one/challan-one.component';
import { WelcomescreenComponent } from './blockchainImpExp/imp_exp/welcomescreen/welcomescreen.component';
import { ForgetPasswordComponent } from './blockchainImpExp/forget-password/forget-password.component';
import { SiteMaintainaceComponent } from './site-maintaince/site-maintainace/site-maintainace.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  //{ path: 'login', component: SiteMaintainaceComponent },
  { path: 'signUp', component: SignUpComponent },
  { path:'challan',component:ChallanOneComponent},
  { path: "welcome", component: WelcomescreenComponent },
  { path: "forget-password", component: ForgetPasswordComponent },
  

  // { path: 'device', component: DeviceComponent },
  // { path: 'group', component: GroupComponent },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
   {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [{
      path: '',
      loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule)

    }]
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true
    })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
